/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ListInvoicesForCompanyInvoiceDtoFromJSON, ListInvoicesForCompanyInvoiceDtoToJSON, } from './ListInvoicesForCompanyInvoiceDto.js';
/**
 * Check if a given object implements the ListInvoicesForCompanyResult interface.
 */
export function instanceOfListInvoicesForCompanyResult(value) {
    if (!('invoices' in value) || value['invoices'] === undefined)
        return false;
    return true;
}
export function ListInvoicesForCompanyResultFromJSON(json) {
    return ListInvoicesForCompanyResultFromJSONTyped(json, false);
}
export function ListInvoicesForCompanyResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'invoices': (json['invoices'].map(ListInvoicesForCompanyInvoiceDtoFromJSON)),
    };
}
export function ListInvoicesForCompanyResultToJSON(json) {
    return ListInvoicesForCompanyResultToJSONTyped(json, false);
}
export function ListInvoicesForCompanyResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'invoices': (value['invoices'].map(ListInvoicesForCompanyInvoiceDtoToJSON)),
    };
}
